export const SubmissionStatus = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  ACCEPTED: "ACCEPTED",
};

export const Categories = {
  THE_BOARD_SECTION: "THE_BOARD_SECTION",
  ADVISORY_BOARD: "ADVISORY_BOARD",
  HEADS_OF_RESEARCH: "HEADS_OF_RESEARCH",
  BRAND_AMBASSADORS: "BRAND_AMBASSADORS",
  FIELD_RESEARCH_OFFICERS: "FIELD_RESEARCH_OFFICERS",
  ADVOCATES: "ADVOCATES",
};
